import AuthService from './authService'
import getAxiosAuthInstance from './axiosAuthInstance'

function useAuth(axiosIns, jwtOverrideConfig) {
  return new AuthService(axiosIns, jwtOverrideConfig)
}

const authInstance = useAuth(getAxiosAuthInstance, {})
export default authInstance
